export const environment = {
    production: false,
    version: '8.0.3',
    APIEndPoint: 'https://api.dev.mfg.com/api/',
    HubEndPointforAppChange: 'https://app.dev.mfg.com/',
    mixpanelProjectKey: '821632dbab87d76ec9b24d3251deb7a1',
  widgetApiKey: ''
};
  


// WEBPACK FOOTER //
// ./src/environments/environment.ts